import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import ListItemText from '@material-ui/core/ListItemText'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import { MyMultiSelectCtrlType, MultipleSelectViewType } from './multiSelectType'
import useMultiSelect from './useMultiSelect'
import { FormHelperText, Grid, Typography } from '@material-ui/core'
import useTranslate from '../../i18n/useTranslate'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
// const MenuProps = {
//     PaperProps: {
//         style: {
//             maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
//             width: 250,
//         },
//     },
// }

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 6.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
    getContentAnchorEl: null,
}

let MultipleSelectView: React.FC<MultipleSelectViewType> = ({
    handleValueChange,
    field,
    required,
    maxLength,
    materialInputProps = {},
    icon,
    defaultValue,
    resetButtom = false,
    label = '',
    option,
    disabled,
    placeholder,
    size = 'small',
    isCheckedAll = false,
    ...props
}) => {
    const { input, meta } = field

    let isError = meta.error && meta.invalid && meta.touched ? true : false
    const classes = useStyles(isError)
    const [valueList, setValueList] = React.useState<string[]>([])
    const [checkAll, setCheckAll] = React.useState<boolean>(false)
    const translate = useTranslate()

    React.useEffect(() => {
        if (!input.value) {
            setValueList([])
        }
    }, [input.value])

    React.useEffect(() => {
        if (defaultValue) {
            setValueList(defaultValue as string[])
            // setCheckAll(true)
        }
    }, [defaultValue])

    React.useEffect(() => {
        if (option && option?.length > 0) {
            if (defaultValue) {
                const dValue = option.map((itm) => itm.value as string)
                const _ = require('lodash')
                if (_.isEqual(defaultValue.sort(), dValue?.sort())) {
                    setCheckAll(true)
                } else {
                    setCheckAll(false)
                }
            }
        }
    }, [option])

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value as any[]
        if (value.some((itmAll) => itmAll === 'all')) {
            const afterCheckedAll = !checkAll
            setCheckAll(afterCheckedAll)

            let _value: any[] | undefined = []
            if (afterCheckedAll) {
                _value = option?.map((item) => item.value)
            }

            input.onChange(_value)
            setValueList(_value as string[])
        } else {
            const OldList = option?.map((item) => item.value)
            const _ = require('lodash')
            if (_.isEqual(value.sort(), OldList?.sort())) {
                setCheckAll(true)
            } else {
                setCheckAll(false)
            }
            input.onChange(value)
            setValueList(value as string[])
        }
    }

    const getLabel = () => {
        const myLabel = required ? (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label || ''}</Typography>
                </Grid>
                <Grid item>
                    <Typography variant={'subtitle2'} style={{ color: 'red' }}>
                        {label ? `*` : ''}
                    </Typography>
                </Grid>
            </Grid>
        ) : (
            <Grid container className={classes.label}>
                <Grid item>
                    <Typography variant={'subtitle2'}>{label || ''}</Typography>
                </Grid>
            </Grid>
        )
        return <Typography variant={'subtitle2'}>{myLabel}</Typography>
    }

    return (
        <div>
            <FormControl variant="outlined" size={size} fullWidth>
                {getLabel()}
                <Select
                    disabled={disabled}
                    multiple
                    error={isError}
                    value={valueList && valueList.length > 0 ? valueList : []}
                    onChange={handleChange}
                    displayEmpty={true}
                    className={disabled ? classes.disable : classes.myStyle}
                    renderValue={(selected) => {
                        const selectedItem = selected as any[]
                        if (selectedItem && selectedItem.length > 0) {
                            var filtered = option?.filter(function (e) {
                                return selectedItem.indexOf(e.value) > -1
                            })

                            let listLabel: any[] = []
                            if (filtered) {
                                listLabel = filtered.map((itm: any) => {
                                    return itm.label
                                })
                            }
                            return <div className={classes.input}>{(listLabel as string[]).join(', ')}</div>
                        } else {
                            return <label style={{ color: '#aaaaa9' }}>{placeholder}</label>
                        }
                    }}
                    MenuProps={{
                        ...MenuProps,
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                    }}
                >
                    {isCheckedAll && (
                        <MenuItem key={'all'} value={'all'} className={checkAll ? classes.myCheckAll : ''}>
                            <Checkbox checked={checkAll} />
                            <ListItemText primary={translate.get('LABEL.CHECKALL')} />
                        </MenuItem>
                    )}
                    {option &&
                        option.map((optionItm) => (
                            <MenuItem key={optionItm.value} value={optionItm.value}>
                                <Checkbox checked={valueList.indexOf(optionItm.value) > -1} />
                                <ListItemText primary={optionItm.label} />
                            </MenuItem>
                        ))}
                </Select>
            </FormControl>
            <FormHelperText className={classes.errorText}>{isError && meta.error}</FormHelperText>
        </div>
    )
}

let MyMultiSelectCtrl: React.FC<MyMultiSelectCtrlType> = ({
    handleValueChange,
    name,
    required,
    validates,
    maxLength,
    ...props
}) => {
    const myMultiselect = useMultiSelect({
        name,
        required,
        validates,
    })
    return <MultipleSelectView required={required} {...myMultiselect} {...props} />
}

export default MyMultiSelectCtrl

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
    myCheckAll: {
        backgroundColor: '#00000014',
    },
    label: {
        marginBottom: 10,
        color: (isError: any) => {
            if (isError) {
                return '#ff4d4f'
            } else {
                return ''
            }
        },
    },
    input: {
        maxWidth: '100%',
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
    },
    myStyle: {
        borderRadius: '8px !important',
    },
    disable: { backgroundColor: '#F0F0F0C6', borderRadius: '8px ' },
    errorText: {
        fontSize: '12px',
        color: '#ff4d4f',
    },
}))
